import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'sixteenth-notes',
  size: 24,
  node: [
    ['path', { d: 'M21 16V3a1 1 0 0 0-1.28-.96l-10 2.917a1 1 0 0 0-.72.96V19', key: 'uy6ho8' }],
    ['path', { d: 'M21 6 9 9.5', key: '1w47ha' }],
    ['circle', { cx: '18', cy: '16', r: '3', key: '1hluhg' }],
    ['circle', { cx: '6', cy: '19', r: '3', key: '1kj8tv' }],
  ],
  aliases: ['music-4'],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name SixteenthNotes
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgMTZWM2ExIDEgMCAwIDAtMS4yOC0uOTZsLTEwIDIuOTE3YTEgMSAwIDAgMC0uNzIuOTZWMTkiIC8+CiAgPHBhdGggZD0iTTIxIDYgOSA5LjUiIC8+CiAgPGNpcmNsZSBjeD0iMTgiIGN5PSIxNiIgcj0iMyIgLz4KICA8Y2lyY2xlIGN4PSI2IiBjeT0iMTkiIHI9IjMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/sixteenth-notes
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SixteenthNotes = createLucideIcon(__iconData);

export default SixteenthNotes;
